import { memo } from 'react'

import { Layout } from 'modules/layout'

import { Questions } from './questions'

const PrivacyPolicy = memo(() => (
  <Layout>
    <Questions />
  </Layout>
))

PrivacyPolicy.displayName = 'PrivacyPolicy'

export default PrivacyPolicy
